import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Format a Square-Footage value as a full integer with thousand separators.
 *  Always shows the actual total — never shortened to K or M.
 *  Example: 2000 -> "2,000"; 12345.6 -> "12,346"
 */
export function fmtSf(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
}

